module.exports = __webpack_public_path__ + "img/curriculum_des_3.cde8894c.jpg";